// Strażnik koszyka konfiguratora — usuwa osierocone dopłaty.
// Grupa linii spięta properties._config_id; łóżko = linia z properties._config_json.
// Dopłaty bez linii łóżka (klient usunął łóżko) są zerowane przez /cart/update.js.
// Działa niezależnie od bed-configurator: ładowany globalnie z theme.liquid (defer).

(function () {
  'use strict';

  const shared = window.kloveCartState ||= {busy:false,uncertain:false};
  let cleaning = false; // anty-pętla: nie startuj drugiego przebiegu w trakcie sprzątania
  let pending = false; // zdarzenie przyszło w trakcie sprzątania → powtórz sprawdzenie po nim
  let queued = false; // zbij serię zdarzeń w jedno sprawdzenie
  let subscribed = false;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  // Strona /cart renderuje <cart-items> (drawer używa <cart-drawer-items>)
  function onCartPage() {
    return !!document.querySelector('cart-items, [data-klove-cart]');
  }

  // Spec: guard działa tylko na stronach z koszykiem (drawer lub /cart)
  function hasCartUI() {
    return !!(document.querySelector('cart-drawer') || document.querySelector('cart-items, [data-klove-cart]'));
  }

  // Zwraca mapę { lineKey: 0 } dla dopłat, których łóżko zniknęło z koszyka
  function findOrphanUpdates(cart) {
    const groups = new Map();
    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      const configId = props._config_id;
      if (!configId) return;
      let group = groups.get(configId);
      if (!group) {
        group = { hasBed: false, addonKeys: [] };
        groups.set(configId, group);
      }
      if (props._config_json) {
        group.hasBed = true;
        group.bedQty = item.quantity;
      } else {
        group.addonKeys.push({ key: item.key, qty: item.quantity });
      }
    });
    const updates = {};
    groups.forEach((group) => {
      if (!group.hasBed) {
        // Sieroty: dopłaty bez łóżka znikają.
        group.addonKeys.forEach((a) => {
          updates[a.key] = 0;
        });
        return;
      }
      // Sync ilości: dopłata zawsze w ilości łóżka (klient zmienił qty
      // łóżka albo samej dopłaty w koszyku — cena ma zostać spójna).
      group.addonKeys.forEach((a) => {
        if (a.qty !== group.bedQty) updates[a.key] = group.bedQty;
      });
    });
    return updates;
  }

  // Podmień sekcje drawera i licznika bez otwierania drawera
  function patchSections(sections) {
    if (!sections) return;
    const drawerEl = document.querySelector('cart-drawer');
    if (sections['cart-drawer'] && drawerEl) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      // Wzór z cart-drawer.js (renderContents): podmiana całego #CartDrawer,
      // dzięki czemu stan pustego koszyka (.drawer__inner-empty) też trafia do DOM
      const target = drawerEl.querySelector('#CartDrawer');
      const source = html.querySelector('#CartDrawer');
      if (target && source) {
        target.innerHTML = source.innerHTML;
        // innerHTML skasował listener overlaya — podepnij zamykanie na nowo
        const overlay = drawerEl.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawerEl.close === 'function') {
          overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
        }
      }
      // Dawn trzyma klasę pustego koszyka na elemencie <cart-drawer> (CSS + focus-trap)
      const sourceDrawer = html.querySelector('cart-drawer');
      if (sourceDrawer) {
        drawerEl.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
      }
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const source = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (bubble && source) bubble.innerHTML = source.innerHTML;
    }
  }

  async function check() {
    if (cleaning) {
      pending = true; // nie gub zdarzenia — powtórz po bieżącym przebiegu
      return;
    }
    if (shared.uncertain || shared.integrityBlocked) return;
    if (shared.busy) { schedule(250); return; }
    cleaning = true;
    shared.busy = true;
    const root = document.querySelector('[data-klove-cart]');
    const controls = [...(root?.querySelectorAll?.('button') || [])].map(control => ({control,disabled:control.disabled}));
    controls.forEach(({control}) => {control.disabled=true;});
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(),15000);
    const rejectCorrection = () => {
      // The server definitively refused a required correction. The known cart is
      // still inconsistent; allow explicit edits/removal, but never checkout.
      shared.integrityBlocked = true;
      let strings = {};
      try { strings=JSON.parse(root?.querySelector('[data-cart-strings]')?.textContent || '{}'); } catch {}
      const message=root?.querySelector('[data-cart-error]');
      if(message) {message.textContent=strings.integrity_error || strings.update_error || window.cartStrings?.error || '';message.hidden=false;}
    };
    let mutationStarted = false;
    try {
      const cartResponse = await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' }, signal:controller.signal });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const updates = findOrphanUpdates(cart);
      if (!Object.keys(updates).length) return; // idempotentnie: nic do sprzątania

      const body = { updates };
      // Poproś od razu o sekcje, jeśli mamy je gdzie wstawić
      const sections = [];
      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      mutationStarted = true;
      const updateResponse = await fetch(updateUrl(), {
        method: 'POST',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      // A gateway error can arrive after Shopify committed the update. Keep the
      // mutation uncertain so checkout/retry requires a fresh cart read.
      if (updateResponse.status === 408 || updateResponse.status >= 500) throw new Error('Unconfirmed cart guard mutation');
      if (!updateResponse.ok) { mutationStarted = false; rejectCorrection(); return; }
      const updated = await updateResponse.json();
      if (updated.status === 408 || updated.status >= 500) throw new Error('Unconfirmed cart guard mutation');
      if (updated.status >= 400) { mutationStarted = false; rejectCorrection(); return; }

      if (onCartPage()) {
        // Strona koszyka: pełne odświeżenie pokazuje aktualne linie i sumy
        window.location.reload();
        return;
      }
      patchSections(updated.sections);
    } catch (error) {
      if (mutationStarted) {
        shared.uncertain = true;
        if (root?.querySelector) {
          let strings = {};
          try { strings=JSON.parse(root.querySelector('[data-cart-strings]')?.textContent || '{}'); } catch {}
          const message=root.querySelector('[data-cart-error]');
          if(message) {message.textContent=strings.uncertain_error || window.cartStrings?.error || '';message.hidden=false;}
          const checkout=root.querySelector('[name="checkout"]');
          if(checkout && strings.refresh_cart) checkout.textContent=strings.refresh_cart;
        }
      }
      console.error('[bed-cart-guard]', error);
    } finally {
      clearTimeout(timeout);
      controls.forEach(({control,disabled}) => {control.disabled=disabled;});
      if (shared.integrityBlocked) { const checkout=root?.querySelector('[name="checkout"]'); if(checkout)checkout.disabled=true; }
      shared.busy = false;
      cleaning = false;
      if (pending && !shared.uncertain && !shared.integrityBlocked) {
        pending = false;
        schedule(0);
      }
    }
  }

  function schedule(delay) {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      check();
    }, delay);
  }

  // Pubsub Dawn jest opcjonalny (ładowany sekcjami) — subskrybuj tylko, gdy dostępny
  function armSubscription() {
    if (subscribed) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
    subscribed = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (data && data.source === 'bed-cart-guard') return;
      // Krótka zwłoka: pozwól Dawn dokończyć własny re-render przed sprzątaniem
      schedule(250);
    });
  }

  armSubscription();
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        armSubscription(); // pubsub.js (defer w sekcjach) jest już wykonany
        if (hasCartUI()) schedule(0);
      },
      { once: true }
    );
  } else {
    armSubscription();
    if (hasCartUI()) schedule(0);
  }
})();
